(() => {
const $9957712f584d7be1$var$tns = typeof window !== "undefined" && window.tns;
const $9957712f584d7be1$var$wrappers = document.querySelectorAll('.block-hero-callout');
// Apply content width to slide content (matches CSS: flex and max-width use var(--content-width))
$9957712f584d7be1$var$wrappers.forEach((wrapper)=>{
    const slideContents = wrapper.querySelectorAll('.hero-callout__slide-content');
    slideContents.forEach((content)=>{
        content.style.flex = '0 0 var(--content-width)';
        content.style.maxWidth = 'var(--content-width)';
    });
});
/**
 * Re-run slide height sync so layout matches after images/layout settle.
 * No refresh() here - it can trigger resize → setSlideHeights → resize loop and crash the tab.
 */ function $9957712f584d7be1$var$runLayoutFix(wrapper, slider, setSlideHeights, allowHeightChanges) {
    setSlideHeights(allowHeightChanges);
}
/**
 * Schedule layout fix after images in the hero block have loaded (or after a short delay).
 * Runs only once per slider to avoid multiple updates and potential loops.
 */ function $9957712f584d7be1$var$scheduleLayoutFixAfterImages(wrapper, slider, setSlideHeights, allowHeightChanges) {
    const key = 'hero-callout-layout-fix-done';
    if (slider[key]) return;
    slider[key] = true;
    const runOnce = ()=>{
        $9957712f584d7be1$var$runLayoutFix(wrapper, slider, setSlideHeights, allowHeightChanges);
    };
    const images = wrapper.querySelectorAll('.hero-callout__slide-image');
    const total = images.length;
    if (total === 0) {
        requestAnimationFrame(()=>{
            requestAnimationFrame(runOnce);
        });
        setTimeout(runOnce, 100);
        return;
    }
    let loaded = 0;
    function onLoad() {
        loaded++;
        if (loaded >= total) requestAnimationFrame(()=>{
            requestAnimationFrame(runOnce);
        });
    }
    images.forEach((img)=>{
        if (img.complete) onLoad();
        else img.addEventListener('load', onLoad);
    });
    setTimeout(runOnce, 150);
}
$9957712f584d7be1$var$wrappers.forEach((wrapper)=>{
    const slider = wrapper.querySelector('.hero-callout-slider');
    if (slider) {
        const allow_height_changes = slider.hasAttribute('data-change-slide-heights') ? true : false;
        // Function to calculate the height of the tallest slide and set all slide heights to match
        function setSlideHeights(allow) {
            if (allow) {
                var slides = slider.querySelectorAll('.hero-callout__slide');
                var tallestSlideHeight = 0;
                slides.forEach(function(slide) {
                    slide.style.height = 'auto';
                    if (slide.offsetHeight > tallestSlideHeight) tallestSlideHeight = slide.offsetHeight;
                });
                slides.forEach(function(slide) {
                    slide.style.height = tallestSlideHeight + 'px';
                });
            }
        }
        if (!$9957712f584d7be1$var$tns) return;
        const new_slider = new $9957712f584d7be1$var$tns({
            container: slider,
            speed: 1200,
            items: 1,
            nav: false,
            controls: false,
            mouseDrag: false,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            mode: "gallery",
            autoHeight: false,
            onInit: function(info) {
                setSlideHeights(allow_height_changes);
                slider.classList.add('slider-ready');
                // Fix CSS transitions for gallery fade effect
                const slides = info.container.querySelectorAll('.tns-item');
                slides.forEach((slide)=>{
                    slide.style.transition = 'opacity 1200ms ease, transform 1200ms ease';
                });
                // Apply content width after slider init (matches CSS)
                const slideContents = wrapper.querySelectorAll('.hero-callout__slide-content');
                slideContents.forEach((content)=>{
                    content.style.flex = '0 0 var(--content-width)';
                    content.style.maxWidth = 'var(--content-width)';
                });
                // Fix first-load sizing: recalc heights after images load / layout settles.
                // Defer so new_slider is assigned (onInit runs synchronously inside tns constructor).
                setTimeout(function() {
                    $9957712f584d7be1$var$scheduleLayoutFixAfterImages(wrapper, slider, setSlideHeights, allow_height_changes);
                }, 0);
            }
        });
        var resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                setSlideHeights(allow_height_changes);
            }, 100);
        });
        // When block is revealed after deferred load, slider may have inited with 0 width — recalc once
        document.addEventListener('hero-callout-loaded', function handler(ev) {
            if (ev.detail && ev.detail.block === wrapper) {
                document.removeEventListener('hero-callout-loaded', handler);
                delete slider['hero-callout-layout-fix-done'];
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        $9957712f584d7be1$var$scheduleLayoutFixAfterImages(wrapper, slider, setSlideHeights, allow_height_changes);
                    });
                });
            }
        });
    }
});

})();
//# sourceMappingURL=hero-callout-slider.js.map
